import React, { useState, useEffect } from 'react';
import { Input, message } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Https from '@/https';
import '@/App.css';
import '@/Login.css';

function App() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [messageApi, messageContextHolder] = message.useMessage();
  const loginConfirm = () => {
    if(username && password) {
      Https.postFormData({
        url: 'api/login',
        data: {
          username,
          password,
          platform_type: 0,
          client_id: 'clientid',
          grant_type: 'password',
        }
      }).then(res => {
        if(res.access_token) {
          messageApi.success('登录成功！');
          dispatch({
            type: 'SET_TOKEN_INFO',
            payload: {
              accessToken: res.access_token,
              refreshToken: res.refresh_token,
              tokenType: res.token_type,
              isFirstLogin: res.isFirstLogin
            }
          })
          dispatch({ type: 'SET_USER_INFO', payload: { username } });
          navigate('/main', { replace: true });
        } else {
          messageApi.error('登录失败！');
        }
      })
    } else {
      messageApi.error('请输入用户名和密码！');
    }
  }

  const keyDownHandler = (e: React.KeyboardEvent<HTMLInputElement | HTMLButtonElement>) => {
    if (e.key === 'Enter') {
      loginConfirm();
    }
  }

  useEffect(() => {
    console.log('reset')
    dispatch({ type: 'RESET' });
  }, [])

  return (
    <section className="App">
      <section className="login-container">
        <section className="login-banner">
          <section className="login-icon"></section>
          <h2>机器人系统管理平台</h2>
          <p>数据管理 · 权限管理 · 系统实时监控</p>
        </section>
        <section className="login-form">
          <h3>管理员登录</h3>
          <form id="loginForm">
            <section className="form-group">
              <label htmlFor="username">账号</label>
              <Input
                type="text"
                id="username"
                className="input"
                value={username}
                placeholder="请输入管理员账号"
                allowClear
                onChange={e => setUsername(e.target.value)
                }
                onKeyDown={keyDownHandler}
                required />
            </section>
            <section className="form-group">
              <label htmlFor="password">密码</label>
              <Input.Password
                id="password"
                className="input"
                placeholder="请输入登录密码"
                value={password}
                allowClear
                onChange={e => setPassword(e.target.value)}
                onKeyDown={keyDownHandler}
                iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              />
            </section>
            {/* 这里有个之前没有关注过的问题，记录如下：
              在form标签中，如果button没有设置type的时候，localhost地址栏端口号后面会带一个？，
              查阅相关的资料后，找到了答案，
              The default type of a button tag is submit which means clicking the button will submit your form (appending the ? to your url).
              可以将form改成其他标签，如section/div, 或者将button的type设置为"button"，
              https://stackoverflow.com/questions/30491742/why-does-a-react-onclick-event-append-a-question-mark-to-my-url，
            */}
            <button
              type="button"
              className="login-btn"
              disabled={!username || !password}
              onClick={loginConfirm}
              onKeyDown={keyDownHandler}>登录
            </button>
          </form>
          <section className="login-footer">© 2026 机器人系统管理平台 版权所有</section>
        </section>
      </section>
      { messageContextHolder }
    </section>
  );
}

export default App;
